import React, { useState, useEffect } from 'react';
import AdminNav from '../components/AdminNav';
import { useNavigate } from 'react-router-dom';
import { LogOut, ArrowRight, Shield } from 'lucide-react';
import { rbacService, authService } from '../services/api';

function AdminPermissions() {
  const navigate = useNavigate();
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const handleLogout = () => {
    authService.logout();
    navigate('/admin-login');
  };

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const res = await rbacService.getPermissions();
        setPermissions(res.data);
      } catch (err) {
        setError('خطا در دریافت دسترسی‌ها');
      } finally {
        setLoading(false);
      }
    };
    fetchPermissions();
  }, []);

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-12">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h1 className="text-4xl font-bold mb-2">دسترسی‌ها</h1>
              <p className="text-xl text-blue-100">لیست ماژول‌ها و دسترسی‌های سیستم</p>
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => navigate('/admin/articles')}
                className="flex items-center gap-2 px-4 py-2 bg-blue-700 hover:bg-blue-600 rounded-lg font-semibold transition"
              >
                <ArrowRight size={18} />
                بازگشت
              </button>
              <button
                onClick={handleLogout}
                className="flex items-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 rounded-lg font-semibold transition"
              >
                <LogOut size={18} />
                خروج
              </button>
            </div>
          </div>
        </div>
      </div>

      <AdminNav />

      <div className="max-w-7xl mx-auto px-4 py-12">
        {error && <div className="bg-red-50 text-red-700 p-4 rounded-lg mb-6">{error}</div>}

        {loading ? (
          <div className="text-center py-12 text-gray-500">در حال بارگذاری...</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {permissions.map(group => (
              <div key={group.module} className="bg-white rounded-xl shadow-md p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center text-blue-700">
                    <Shield size={20} />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">{group.module}</h3>
                </div>
                <div className="space-y-2">
                  {group.permissions.map(p => (
                    <div key={p.id} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                      <span className="text-sm text-gray-700">{p.action}</span>
                      <code className="text-xs text-gray-500 bg-gray-200 px-2 py-0.5 rounded">{p.key}</code>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminPermissions;
